import styled from 'styled-components';

const ReportArchivesTitleBar = styled.div`
  background-color: ${(props): string => props.theme.colors.paleBlue};
  padding: ${(props): string =>
    `${props.theme.spaces.md} ${props.theme.spaces.xl}`};
`;

export { ReportArchivesTitleBar };
